var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default",function(){return [_c('v-btn',{attrs:{"color":"grey","outline":""},on:{"click":_vm.exportxlsx}},[_c('em',{staticClass:"fas fa-file-export"}),_vm._v("\n       \n      "+_vm._s(_vm.$t('export'))+" \n    ")])]},null,{ exportxlsx: _vm.exportxlsx })],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e0185fd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Exportxlsx2.vue
// module id = null
// module chunks = 